import React from 'react';
import { InHouseShipmentComponent } from '../components/inhouse/InHouseShipment';

export const InHouseShipment: React.FC = () => {
  return <InHouseShipmentComponent />;
};
